import ApplicationSerializer from './application';

export default class RecurringInviteSerializer extends ApplicationSerializer {
  attrs = {
    locationNames: {
      serialize: false,
    },
    recurringGroupInvite: {
      serialize: false,
    },
  };
}
